import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import ViewClient from "./view.client";
import ViewProducts from "./view.products";
import {CgOrganisation} from "react-icons/cg";
import {
    MdCalendarToday,
    MdClose,
    MdComment,
    MdEdit,
    MdLocationCity,
    MdLocationPin,
    MdMoney,
    MdOutlinePhone,
    MdPhone,
} from "react-icons/md";
import {BsCardChecklist} from "react-icons/bs";
import {MdPerson, MdSave} from "react-icons/md";
import phoneNumberFormatter from "../globalFunction/telefon";
import moment from "moment";
import {TbTruckDelivery} from "react-icons/tb";
import ViewManager from "./viewManager";
import {useContext, useState} from "react";
import {BiReset} from "react-icons/bi";
import UpdateOrderHistory from "./update.order.full";
import {RequestContext} from "../../context/request.context";
import numberFormat from "../globalFunction/prettierNumber";
import dateTimeFormat from "../globalFunction/prettierDate";

const FullInfoView = ({fullData, show = false}) => {
    const {request} = useContext(RequestContext);
    const [data, setData] = useState(fullData);
    const [isChanged, setIsChanged] = useState({
        forName: false,
        forProducts: false,
    });
    const [dialog, setDialog] = useState({
        open: false,
        component: null,
    });
    const [updateDialog, setUpdateDialog] = useState({
        open: false,
        component: null,
    });
    const client = (data) => {
        return [
            {
                name_uz: "F.I.SH",
                value: data.name,
                icon: <BsCardChecklist/>,
            },
            {
                name_uz: "Manzili",
                value: data.address,
                icon: <MdLocationPin/>,
            },
            {
                name_uz: "Telefon raqami",
                value: phoneNumberFormatter(data.phoneNumber),
                icon: <MdOutlinePhone/>,
            },
            {
                name_uz: "Telefon raqami 2",
                value: phoneNumberFormatter(data.phoneNumber2),
                icon: <MdPhone/>,
            },
            {
                name_uz: "Tashkilot",
                value: data.organization,
                icon: <CgOrganisation/>,
            },
            {
                name_uz: "Region",
                value: data.region.name,
                icon: <MdLocationCity/>,
            },
        ];
    };
    const manager = (obj) => {
        return [
            {
                name_uz: "Buyurtma agenti",
                value: obj.name,
                icon: <MdPerson/>,
            },
            {
                name_uz: "Sana",
                value: moment(obj.createdAt).format("DD.MM.YYYY HH:mm"),
                icon: <MdCalendarToday/>,
            },
            {
                name_uz: "Narx turi",
                value: obj.priceTypeName,
                icon: <MdMoney/>,
            },
            {
                name_uz: "Region",
                value: obj.region.name,
                icon: <MdLocationCity/>,
            },
            {
                name_uz: "Yetkazib berish",
                value: data.delivery ? "Ha" : "Yo'q",
                icon: <TbTruckDelivery/>,
            },
            {
                name_uz: "Izoh",
                value: data.description,
                icon: <MdComment/>,
            },
        ];
    };

    const updateAll = async (data) => {
        const json = {
            clientId: data.client?.id,
            cbClientId: data.cbClient?.id,
            products: data.products.map((item) => ({
                name: item.name,
                price: item.price * 1,
                sum: item.sum * 1,
                quantity: item.quantity,
                priceType: item.priceType,
                productId: item.productId,
            })),
            description: data.description,
            amountPayment: data.amountPayment,
            discount: data.discount,
            probablyDeliveryDate: data.probablyDeliveryDate,
            isDelivery: data.isDelivery,
            address: data.address,
        };
        const res = await request(`/order/${data.id}`, "PUT", json);
        if (res) {
            setIsChanged({forName: false, forProducts: false});
            setData(res);
        }
    };

    return (
        <Box>
            {show && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: "1%",
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                        backgroundColor: "background.paper",
                    }}
                >
                    {isChanged.forName && isChanged.forProducts && (
                        <Button
                            variant="contained"
                            startIcon={<MdSave/>}
                            onClick={async () => {
                                await updateAll(data);
                            }}
                        >
                            Saqlash
                        </Button>
                    )}
                    {fullData.createdOrder && (
                        <Tooltip title="Boshlang'ich holatini ko'rish">
                            <IconButton
                                onClick={() => {
                                    setDialog({
                                        open: true,
                                        component: <FullInfoView fullData={fullData}/>,
                                    });
                                }}
                            >
                                <BiReset/>
                            </IconButton>
                        </Tooltip>
                    )}
                    <Tooltip title="O'zgartirish">
                        <IconButton
                            onClick={() => {
                                setUpdateDialog({
                                    open: true,
                                    component: (
                                        <UpdateOrderHistory
                                            data={data}
                                            updateData={(json) => {
                                                setData((prev) => ({...prev, ...json}));
                                                setUpdateDialog({open: false, component: null});
                                                setIsChanged((prev) => ({...prev, forName: true}));
                                            }}
                                        />
                                    ),
                                });
                            }}
                        >
                            <MdEdit/>
                        </IconButton>
                    </Tooltip>
                </Box>
            )}
            <Box
                sx={{
                    padding: "2%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "top",
                        gap: "1rem",
                        mb: "2rem",
                        "@media (max-width: 1300px)": {
                            gridTemplateColumns: "1fr",
                        },
                    }}
                >
                    {data?.client ? (
                        <ViewClient
                            data={data.client}
                            clientObj={client(data?.client)}
                            type="client"
                        />
                    ) : (
                        <ViewManager data={data} obj={data?.cbClient} type="cbClient"/>
                    )}
                    <Box
                        sx={{
                            width: "50%",
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.5rem",
                            alignItems: "flex-start",
                        }}
                    >
                        <ViewClient
                            data={data?.user}
                            order={data}
                            clientObj={manager(data?.user)}
                            type="manager"
                        />
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                height: "100%",
                                backgroundColor: "action.hover",
                                borderRadius: "0.5rem",
                                padding: "0.5rem",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    height: 40,
                                    gap: "0.5rem",
                                    borderBottom: "1px solid #e0e0e0",
                                }}
                            >
                                <Box
                                    sx={{

                                        width: "50%",
                                    }}
                                >
                                    <Typography variant="body1">Manzil</Typography>
                                </Box>
                                <Box
                                    sx={{
                                        width: "50%",
                                    }}
                                >
                                    <Typography variant="body1">
                                        {data.address || "-"}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    height: 40,
                                    gap: "0.5rem",
                                    borderBottom: "1px solid #e0e0e0",
                                }}
                            >
                                <Box
                                    sx={{

                                        width: "50%",
                                    }}
                                >
                                    <Typography variant="body1">
                                        Yetkazib berish sanasi
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        width: "50%",
                                    }}
                                >
                                    <Typography variant="body1">
                                        {dateTimeFormat(data.probablyDeliveryDate)}
                                    </Typography>
                                </Box>
                            </Box>
                            {/*amountCashPayment*/}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    height: 40,
                                    gap: "0.5rem",
                                    borderBottom: "1px solid #e0e0e0",
                                }}
                            >
                                <Box
                                    sx={{

                                        width: "50%",
                                    }}
                                >
                                    <Typography variant="body1">Naqt pulda to'lov</Typography>
                                </Box>
                                <Box
                                    sx={{
                                        width: "50%",
                                    }}
                                >
                                    <Typography variant="body1">
                                        {numberFormat(data.amountCashPayment)}
                                    </Typography>
                                </Box>
                            </Box>
                            {/*amountCardPayment*/}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    height: 40,
                                    gap: "0.5rem",
                                    borderBottom: "1px solid #e0e0e0",
                                }}>
                                <Box
                                    sx={{
                                        width: "50%",
                                    }}>
                                    <Typography variant="body1">Plastikda to'lov</Typography>
                                </Box>
                                <Box
                                    sx={{
                                        width: "50%",
                                    }}>
                                    <Typography variant="body1">
                                        {numberFormat(data.amountCardPayment)}
                                    </Typography>
                                </Box>
                            </Box>
                            {/*amountTransferPayment*/}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    height: 40,
                                    gap: "0.5rem",
                                    borderBottom: "1px solid #e0e0e0",
                                }}>
                                <Box
                                    sx={{
                                        width: "50%",
                                    }}>
                                    <Typography variant="body1">Pul o'tkazmasi</Typography>
                                </Box>
                                <Box
                                    sx={{
                                        width: "50%",
                                    }}>
                                    <Typography variant="body1">
                                        {numberFormat(data.amountTransferPayment)}
                                    </Typography>
                                </Box>
                            </Box>
                            {(data.latitude && data.longitude) &&
                                // iframe for map
                                <div>
                                    <iframe
                                        title="location"
                                        width="100%"
                                        height="450"
                                        src={`https://maps.google.com/maps?q=${data.latitude},${data.longitude}&z=15&output=embed`}
                                        loading="lazy"
                                    />
                                </div>
                            }
                        </Box>
                    </Box>
                </Box>
                <ViewProducts
                    products={data.products}
                    currentRow={data}
                    updateButton={() => {
                        setIsChanged((prev) => ({...prev, forProducts: true}));
                    }}
                    getRow={(row) => {
                        setData(row);
                    }}
                />
            </Box>

            <Dialog
                open={dialog.open}
                onClose={() => setDialog({open: false})}
                fullScreen
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                        backgroundColor: "background.paper",
                        borderBottom: 1,
                        borderColor: "divider",
                    }}
                >
                    <Typography variant="h6">
                        Boshlang'ich holatga nisbatan analiz
                    </Typography>
                    <IconButton onClick={() => setDialog({open: false})}>
                        <MdClose/>
                    </IconButton>
                </DialogTitle>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        alignItems: "center",
                    }}
                >
                    <DialogContent
                        sx={{
                            borderRight: "1px solid #ccc",
                            // as green
                            background: "lemonchiffon",
                        }}
                    >
                        <Box>
                            <Typography variant="h6" textAlign={"center"}>
                                Hozirgi holat
                            </Typography>
                            <FullInfoView fullData={fullData}/>
                        </Box>
                    </DialogContent>
                    <DialogContent>
                        <Box>
                            <Typography variant="h6" textAlign={"center"}>
                                Boshlang'ich holat
                            </Typography>
                            <FullInfoView fullData={fullData.createdOrder}/>
                        </Box>
                    </DialogContent>
                </Box>
            </Dialog>
            <Dialog
                open={updateDialog.open}
                onClose={() =>
                    setUpdateDialog({
                        open: false,
                        component: null,
                    })
                }
                fullWidth
            >
                {updateDialog.component}
            </Dialog>
        </Box>
    );
};

export default FullInfoView;
